import routerOptions0 from "/runner/_work/l-box-user-front/l-box-user-front/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.5_db0@0.2.3_eslint@9.21.0_jiti@2.4._103fb67aa33199702657308e2b33f11a/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}